export default {
  'emailTemplates.title': 'Gestionar Formatos de Correo',
  'emailTemplates.dowloadBaseTemplate': 'Descargar Plantilla Base',
  'emailTemplates.mailFormat': 'Formato de Correo',
  'emailTemplates.seeAdvancedEdition': 'ver Edición Avanzada',
  'emailTemplates.hideAdvancedEditing': 'Ocultar Edición Avanzada',
  'emailTemplates.form.action': 'Accción',
  'emailTemplates.form.fromName': 'Nombre Remitente',
  'emailTemplates.form.subject': 'Asunto',

  'emailTemplates.requestPendingApproval': 'Solicitud Pendiente de Aprobación',
  'emailTemplates.requestPendingCompleteInformation': 'Solicitud de Información Completa Pendiente',
  'emailTemplates.requestPendingTaskCompletion': 'Solicitud de Finalización de Tarea Fendiente',
  'emailTemplates.requestApproved': 'Solicitud Aprobada',
  'emailTemplates.requestRejected': 'Solicitud Rechazada',
  'emailTemplates.requestCanceled': 'Solicitud Cancelada',
  'emailTemplates.accountConfirmation': 'Confirmación de Cuenta',
  'emailTemplates.accountWelcomeMessage': 'Mensaje de bienvenida a la Cuenta',
  'emailTemplates.accountResetPassword': 'Restablecer la contraseña de la Cuenta',
  'emailTemplates.requestAttachments': 'Solicitar Anexos',
  'emailTemplates.executionSteps': 'Pasos de Ejecución',
  'emailTemplates.requestPendingSignature': 'Solicitud Pendiente de Firma',
  'emailTemplates.actionSendEmail': 'Acción Enviar Correo Electrónico',
  'emailTemplates.requestScheduledExecution': 'Solicitud de Ejecución Programada',
  'emailTemplates.accountTwoFactorValidationCode':
    'Código de validación de dos factores de la cuenta',
};
